export default {"src":"/_next/static/media/twitter-brands.a207e8e3.svg","height":512,"width":512};